module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container direct-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table summary-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center inform-transfer"
  }, [_c('p', [_vm._v("จำนวนเงิน ฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success"
  }, [_vm._v("แจ้งการชำระแล้วเงินที่ Email: zeekdoc@yahoo.com หรือ โทร 092-462-6633 (ฟ้า)")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("ชำระค่าบริการ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "text-center direct-detail-title"
  }, [_vm._v("ชำระค่าบริการโดยการโอนเงินที่บัญชี")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('div', {
    staticClass: "direct-detail"
  }, [_c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": "/static/img/kbank.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bank-detail"
  }, [_c('p', {
    staticClass: "bank-name"
  }, [_vm._v("ธนาคารกสิกรไทย (K-BANK)")]), _vm._v(" "), _c('p', {
    staticClass: "account-number"
  }, [_vm._v("เลขที่บัญชี: 008-1-22010-7")]), _vm._v(" "), _c('p', {
    staticClass: "account-name"
  }, [_vm._v("ชื่อบัญชี: บจก. ซีคด็อก")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b81a28f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/package/payment/direct.vue
// module id = 1037
// module chunks = 1